var _objectSpread = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: ["icon", classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "200",
        "height": "200",
        "viewBox": "0 0 1024 1024",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M895.616 333.12c-3.36 75.008-55.616 177.504-156.608 307.744C634.496 776.736 546.24 844.736 473.984 844.736c-44.864 0-82.72-41.376-113.6-124.096-20.768-76-41.376-151.904-62.016-227.776-23.008-82.88-47.616-124.224-73.984-124.224-5.76 0-25.888 12.096-60.256 36.224L128 358.24a11308.32 11308.32 0 00112.128-100.128c50.496-43.712 88.512-66.752 113.76-69.12 59.744-5.76 96.64 35.136 110.368 122.752 14.88 94.624 25.248 153.376 31.008 176.384 17.248 78.496 36.224 117.632 56.96 117.632 16 0 40.16-25.376 72.416-76.256 32.096-51.008 49.376-89.6 51.744-116.256 4.48-43.872-12.768-65.888-51.744-65.888-18.4 0-37.376 4.16-56.896 12.512 37.76-123.744 109.888-184 216.384-180.48 78.88 2.24 116 53.472 111.488 153.728z"
      }
    })]));
  }
};